module.exports = __webpack_public_path__ + "static/media/battery-full.c365d3d9.svg";